// Header menus data =================================================================
import CanvasColoredIcon from "static/svg/header/canvas_colored.svg";
import WorkformsColoredIcon from "static/svg/header/workforms_colored_1.svg";
import MarketingColoredIcon from "static/svg/header/marketing_colored.svg";
import DevColoredIcon from "static/svg/header/dev_colored.svg";
import ITColoredIcon from "static/svg/header/it_colored_1.svg";
import OperationsColoredIcon from "static/svg/header/operations_colored.svg";
import PMOColoredIcon from "static/svg/header/pmo_colored.svg";
import SalesColoredIcon from "static/svg/header/sales_colored_1.svg";
import HRColoredIcon from "static/svg/header/hr_colored_1.svg";
import EnterpriseColoredIcon from "static/svg/header/enterprise_colored_1.svg";
import SmbColoredIcon from "static/svg/header/small_business_colored_1.svg";
import NonprofitColoredIcon from "static/svg/header/nonprofit_colored.svg";
//import BoardsColoredIcon from "static/svg/header/boards_colored.svg";
import DocsColoredIcon from "static/svg/header/docs_colored.svg";
import FilesColoredIcon from "static/svg/header/files_colored.svg";
import GanttColoredIcon from "static/svg/header/gantt_colored.svg";
import KanbanColoredIcon from "static/svg/header/kanban_colored.svg";
import AutomationsColoredIcon from "static/svg/header/automations_colored.svg";
import IntegrationsColoredIcon from "static/svg/header/integrations_colored.svg";
import DashboardsColoredIcon from "static/svg/header/dashboards_colored.svg";
//import EnterpriseAgilityColoredIcon from "static/svg/header/enterprise_agility_colored.svg";
import MoreWorkflowsColoredIcon from "static/svg/header/more_workflows_colored_2.svg";
import ProjectManagementColoredIcon from "static/svg/header/project_management_colored_2.svg";
import RemoteWorkColoredIcon from "static/svg/header/remote_work_colored_2.svg";
import InventoryTrackingColoredIcon from "static/svg/header/inventory_tracking_colored_2.svg";
import MondayCRMSquareIcon from "static/svg/header/monday_crm_square.svg";
import MondayMarketerSquareIcon from "static/svg/header/monday_marketer_square.svg";
import MondayProjectsSquareIcon from "static/svg/header/monday_projects_square.svg";
import MondayDevSquareIcon from "static/svg/header/monday_dev_square.svg";
import CRMIcon from "static/svg/header/mobile_crm_logo.svg";
import MarketerIcon from "static/svg/header/mobile_marketer_logo.svg";
import ProjectsIcon from "static/svg/header/mobile_projects_logo.svg";
import DevIcon from "static/svg/header/mobile_dev_logo.svg";

import {
  BACKGROUND_GRAY_COLOR_NAME,
  CRM_GREEN_COLOR_NAME,
  DEV_GREEN_COLOR_NAME,
  MARKETING_RED_COLOR_NAME,
  PROJECTS_ORANGE_COLOR_NAME
} from "styles/color-consts";

import {
  INTEGRATIONS_PAGE_LINK,
  APPS_MARKETPLACE_LINK,
  APPS_DEVELOPER_LINK,
  REMOTE_WORK_USE_CASES_LINK,
  PROJECT_MANAGEMENT_MINI_SITE_LINK,
  SOFTWARE_MINI_SITE_LINK,
  MARKETING_MANAGEMENT_MINI_SITE_LINK,
  IT_OPERATIONS_USE_CASES_LINK_V2,
  HR_USE_CASES_LINK,
  CRM_MINI_SITE_LINK,
  CUSTOMERS_PAGE_LINK,
  OPERATIONS_CLUSTER_LINK,
  INVENTORY_WORKFLOW_LINK,
  SMB_PAGE_LINK,
  ENTERPRISE_PAGE_LINK,
  TEMPLATE_CENTER_PAGE_LINK,
  AUTOMATIONS_PAGE_LINK,
  GANTT_PAGE_LINK,
  KANBAN_PAGE_LINK,
  DASHBOARDS_PAGE_LINK,
  WORKFORMS_HOMEPAGE_LINK,
  CANVAS_HOMEPAGE_LINK,
  WORKDOCS_PAGE_LINK,
  NGO_PAGE_LINK,
  FILES_PAGE_LINK,
  ABOUT_US_PAGE_LINK,
  BLOG_PAGE_LINK,
  DIGITAL_LIFT_LINK,
  PARTNERS_PAGE_LINK,
  WEBINARS_PAGE_LINK,
  KNOWLEDGE_BASE_LINK,
  SUPPORT_PAGE_LINK,
  GLOBAL_EVENTS_PAGE_LINK,
  CAREERS_PAGE_LINK
} from "constants/links";
import { hexToRgba } from "utils/general";
import colors from "styles/colors";

export const PRODUCTS_MENU_ID = "products";
export const USE_CASES_MENU_ID = "use-cases";
export const FEATURES_MENU_ID = "features";
export const RESOURCES_MENU_ID = "resources";

export const DESKTOP_HEADER_BASE_CLASS_NAME = "base-header-desktop-component";

export const PRODUCTS_PRODUCTS_TEXTS_SECTION_ID = "products-texts";
export const PRODUCTS_PRODUCTS_SECTION_ID = "products";
export const PRODUCTS_MORE_SECTION_ID = "more";
export const USE_CASES_BY_TEAM_SECTION_ID = "by-team";
export const USE_CASES_BY_BUSINESS_SIZE_SECTION_ID = "by-business-size";
export const USE_CASES_BY_WORKFLOW_SECTION_ID = "by-workflow";
export const FEATURES_KEY_FEATURES_SECTION_ID = "key-features";
export const RESOURCES_LEARN_SECTION_ID = "learn";
export const RESOURCES_CONNECT_SECTION_ID = "connect";
export const RESOURCES_EXPLORE_SECTION_ID = "explore";
export const RESOURCES_TOP_STORIES_SECTION_ID = "top-stories";

export const ICON_TYPES = {
  fill: "fill",
  outline: "outline"
};

export const MENU_SECTION_CLASSNAMES = {
  products: "products",
  mondayProducts: "mondayProducts",
  useCases: "use-cases",
  features: "features",
  resources: "resources"
};

export const MENU_SECTION_ITEM_TYPE = {
  base: "base",
  product: "product",
  secondaryProduct: "secondary-product",
  useCase: "use-case",
  useCaseByWorkflow: "use-case-by-workflow",
  feature: "feature",
  resource: "resource",
  story: "story"
};

const productsSectionMenuItems = [
  {
    id: PRODUCTS_PRODUCTS_TEXTS_SECTION_ID,
    classname: MENU_SECTION_CLASSNAMES.products,
    maxNumberOfItemsInColumn: 1,
    title: "header.products.section.text.title",
    subtitle: "header.products.section.text.subtitle",
    menuSectionItems: [],
    noSeparator: true,
    hideOnMobile: true
  },
  {
    id: PRODUCTS_PRODUCTS_SECTION_ID,
    mobileTitle: "header.products.section.products.mobileTitle",
    classname: MENU_SECTION_CLASSNAMES.mondayProducts,
    maxNumberOfItemsInColumn: 4,
    menuSectionItems: [
      {
        itemType: MENU_SECTION_ITEM_TYPE.product,
        mobileIcon: CRMIcon,
        icon: MondayCRMSquareIcon,
        iconStrokeColor: colors.gainsboro,
        iconType: ICON_TYPES.fill,
        title: "header.tabs.products.mondaySalesCRM.title",
        subtitle: "header.tabs.products.mondaySalesCRM.subtitle",
        url: CRM_MINI_SITE_LINK,
        hoverBackgroundColor: hexToRgba(colors[CRM_GREEN_COLOR_NAME], 0.16),
        tags: {
          title: "header.tabs.products.tags.title",
          color: "#025050",
          backgroundColor: hexToRgba(colors[CRM_GREEN_COLOR_NAME], 0.16),
          list: [
            "header.tabs.products.mondaySalesCRM.tags.tag1",
            "header.tabs.products.mondaySalesCRM.tags.tag2",
            "header.tabs.products.mondaySalesCRM.tags.tag3"
          ]
        }
      },
      {
        itemType: MENU_SECTION_ITEM_TYPE.product,
        mobileIcon: MarketerIcon,
        icon: MondayMarketerSquareIcon,
        iconStrokeColor: colors.gainsboro,
        iconType: ICON_TYPES.fill,
        title: "header.tabs.products.mondayMarketer.title",
        subtitle: "header.tabs.products.mondayMarketer.subtitle",
        url: MARKETING_MANAGEMENT_MINI_SITE_LINK,
        hoverBackgroundColor: hexToRgba(colors[MARKETING_RED_COLOR_NAME], 0.16),
        tags: {
          title: "header.tabs.products.tags.title",
          color: "#9A0550",
          backgroundColor: hexToRgba(colors[MARKETING_RED_COLOR_NAME], 0.08),
          list: [
            "header.tabs.products.mondayMarketer.tags.tag1",
            "header.tabs.products.mondayMarketer.tags.tag2",
            "header.tabs.products.mondayMarketer.tags.tag3"
          ]
        }
      },
      {
        itemType: MENU_SECTION_ITEM_TYPE.product,
        mobileIcon: ProjectsIcon,
        icon: MondayProjectsSquareIcon,
        iconStrokeColor: colors.gainsboro,
        iconType: ICON_TYPES.fill,
        title: "header.tabs.products.mondayProjects.title",
        subtitle: "header.tabs.products.mondayProjects.subtitle",
        url: PROJECT_MANAGEMENT_MINI_SITE_LINK,
        hoverBackgroundColor: hexToRgba(colors[PROJECTS_ORANGE_COLOR_NAME], 0.16),
        tags: {
          title: "header.tabs.products.tags.title",
          color: "#BC5004",
          backgroundColor: hexToRgba(colors[PROJECTS_ORANGE_COLOR_NAME], 0.08),
          list: [
            "header.tabs.products.mondayProjects.tags.tag1",
            "header.tabs.products.mondayProjects.tags.tag2",
            "header.tabs.products.mondayProjects.tags.tag3"
          ]
        }
      },
      {
        itemType: MENU_SECTION_ITEM_TYPE.product,
        mobileIcon: DevIcon,
        icon: MondayDevSquareIcon,
        iconStrokeColor: colors.gainsboro,
        iconType: ICON_TYPES.fill,
        title: "header.tabs.products.mondayDev.title",
        subtitle: "header.tabs.products.mondayDev.subtitle",
        url: SOFTWARE_MINI_SITE_LINK,
        hoverBackgroundColor: hexToRgba(colors[DEV_GREEN_COLOR_NAME], 0.16),
        tags: {
          title: "header.tabs.products.tags.title",
          color: "#015727",
          backgroundColor: hexToRgba(colors[DEV_GREEN_COLOR_NAME], 0.08),
          list: [
            "header.tabs.products.mondayDev.tags.tag1",
            "header.tabs.products.mondayDev.tags.tag2",
            "header.tabs.products.mondayDev.tags.tag3"
          ]
        }
      }
    ]
  },
  {
    id: PRODUCTS_MORE_SECTION_ID,
    title: "header.products.section.more",
    titleLine: true,
    menuSectionItems: [
      {
        itemType: MENU_SECTION_ITEM_TYPE.secondaryProduct,
        icon: WorkformsColoredIcon,
        iconType: ICON_TYPES.fill,
        title: "header.tabs.products.more.workForms.title",
        description: "header.tabs.products.more.workForms.description.with.break",
        url: WORKFORMS_HOMEPAGE_LINK,
        openInNewTab: true
      },
      {
        itemType: MENU_SECTION_ITEM_TYPE.secondaryProduct,
        icon: CanvasColoredIcon,
        iconType: ICON_TYPES.fill,
        title: "header.tabs.products.more.canvas.title",
        description: "header.tabs.products.more.canvas.description",
        url: CANVAS_HOMEPAGE_LINK,
        openInNewTab: true
      }
    ]
  }
];

const useCasesSectionMenuItems = [
  {
    id: USE_CASES_BY_TEAM_SECTION_ID,
    title: "header.useCases.section.byTeam",
    titleLine: true,
    classname: MENU_SECTION_CLASSNAMES.useCases,
    maxNumberOfItemsInColumn: 4,
    menuSectionItems: [
      {
        itemType: MENU_SECTION_ITEM_TYPE.useCase,
        icon: MarketingColoredIcon,
        iconColor: MARKETING_RED_COLOR_NAME,
        title: "header.tabs.workflows.byTeam.marketing",
        url: MARKETING_MANAGEMENT_MINI_SITE_LINK,
        outline: true
      },
      {
        itemType: MENU_SECTION_ITEM_TYPE.useCase,
        icon: DevColoredIcon,
        iconColor: DEV_GREEN_COLOR_NAME,
        title: "header.tabs.workflows.byTeam.developers",
        url: SOFTWARE_MINI_SITE_LINK,
        outline: true
      },
      {
        itemType: MENU_SECTION_ITEM_TYPE.useCase,
        icon: OperationsColoredIcon,
        title: "header.tabs.workflows.byTeam.operations",
        url: OPERATIONS_CLUSTER_LINK,
        outline: true
      },
      {
        itemType: MENU_SECTION_ITEM_TYPE.useCase,
        icon: HRColoredIcon,
        title: "header.tabs.workflows.byTeam.hr",
        url: HR_USE_CASES_LINK,
        outline: true
      },
      {
        itemType: MENU_SECTION_ITEM_TYPE.useCase,
        icon: SalesColoredIcon,
        iconColor: CRM_GREEN_COLOR_NAME,
        title: "header.tabs.workflows.byTeam.sales",
        url: CRM_MINI_SITE_LINK,
        outline: true
      },
      {
        itemType: MENU_SECTION_ITEM_TYPE.useCase,
        icon: PMOColoredIcon,
        iconColor: PROJECTS_ORANGE_COLOR_NAME,
        title: "header.tabs.workflows.byTeam.pmo",
        url: PROJECT_MANAGEMENT_MINI_SITE_LINK,
        outline: true
      },
      {
        itemType: MENU_SECTION_ITEM_TYPE.useCase,
        icon: ITColoredIcon,
        title: "header.tabs.workflows.byTeam.it",
        url: IT_OPERATIONS_USE_CASES_LINK_V2,
        outline: true
      }
    ]
  },
  {
    id: USE_CASES_BY_BUSINESS_SIZE_SECTION_ID,
    title: "header.useCases.section.byBusinessSize",
    titleLine: true,
    classname: MENU_SECTION_CLASSNAMES.useCases,
    maxNumberOfItemsInColumn: 4,
    menuSectionItems: [
      {
        itemType: MENU_SECTION_ITEM_TYPE.useCase,
        icon: EnterpriseColoredIcon,
        title: "header.tabs.workflows.byBusinessSize.enterprise",
        url: ENTERPRISE_PAGE_LINK
      },
      {
        itemType: MENU_SECTION_ITEM_TYPE.useCase,
        icon: SmbColoredIcon,
        title: "header.tabs.workflows.byBusinessSize.smallBusiness",
        url: SMB_PAGE_LINK
      },
      {
        itemType: MENU_SECTION_ITEM_TYPE.useCase,
        icon: NonprofitColoredIcon,
        title: "header.tabs.workflows.byBusinessSize.nonprofit",
        url: NGO_PAGE_LINK
      }
    ]
  },
  {
    id: USE_CASES_BY_WORKFLOW_SECTION_ID,
    title: "header.useCases.section.byWorkflow",
    titleLine: true,
    classname: MENU_SECTION_CLASSNAMES.useCases,
    maxNumberOfItemsInColumn: 3,
    menuSectionItems: [
      // {
      // itemType: MENU_SECTION_ITEM_TYPE.useCaseByWorkflow,
      //   icon: EnterpriseAgilityColoredIcon,
      //   title: "header.tabs.workflows.byWorkflow.enterpriseAgility.title",
      //   description: "header.tabs.workflows.byWorkflow.enterpriseAgility.description",
      //   isPopular: true,
      //   badgeText: "header.menuItem.comingSoon",
      //   badgeColorName: PEACH_COLOR_NAME
      // },
      {
        itemType: MENU_SECTION_ITEM_TYPE.useCaseByWorkflow,
        icon: ProjectManagementColoredIcon,
        title: "header.tabs.workflows.byWorkflow.projectManagement.title",
        description: "header.tabs.workflows.byWorkflow.projectManagement.description",
        url: PROJECT_MANAGEMENT_MINI_SITE_LINK
      },
      {
        itemType: MENU_SECTION_ITEM_TYPE.useCaseByWorkflow,
        icon: RemoteWorkColoredIcon,
        title: "header.tabs.workflows.byWorkflow.remoteWork.title",
        description: "header.tabs.workflows.byWorkflow.remoteWork.description",
        url: REMOTE_WORK_USE_CASES_LINK
      },
      {
        itemType: MENU_SECTION_ITEM_TYPE.useCaseByWorkflow,
        icon: InventoryTrackingColoredIcon,
        title: "header.tabs.workflows.byWorkflow.inventoryTracking.title",
        description: "header.tabs.workflows.byWorkflow.inventoryTracking.description",
        url: INVENTORY_WORKFLOW_LINK
      },
      {
        itemType: MENU_SECTION_ITEM_TYPE.useCaseByWorkflow,
        icon: MoreWorkflowsColoredIcon,
        title: "header.tabs.workflows.byWorkflow.moreWorkflows.title",
        description: "header.tabs.workflows.byWorkflow.moreWorkflows.description",
        url: TEMPLATE_CENTER_PAGE_LINK
      }
    ]
  }
];

const featuresSectionMenuItems = [
  {
    id: FEATURES_KEY_FEATURES_SECTION_ID,
    title: "header.features.section.keyFeatures",
    titleLine: true,
    classname: MENU_SECTION_CLASSNAMES.features,
    maxNumberOfItemsInColumn: 2,
    menuSectionItems: [
      // {
      //   itemType: MENU_SECTION_ITEM_TYPE.feature,
      //   icon: BoardsColoredIcon,
      //   title: "header.tabs.features.keyFeatures.boards.title",
      //   description: "header.tabs.features.keyFeatures.boards.description",
      //   outline: true,
      //   url: HR_USE_CASES_LINK,
      // },
      {
        itemType: MENU_SECTION_ITEM_TYPE.feature,
        icon: DashboardsColoredIcon,
        title: "header.tabs.features.keyFeatures.dashboards.title",
        description: "header.tabs.features.keyFeatures.dashboards.description",
        outline: true,
        url: DASHBOARDS_PAGE_LINK
      },
      {
        itemType: MENU_SECTION_ITEM_TYPE.feature,
        icon: IntegrationsColoredIcon,
        title: "header.tabs.features.keyFeatures.integrations.title",
        description: "header.tabs.features.keyFeatures.integrations.description",
        outline: true,
        url: INTEGRATIONS_PAGE_LINK
      },
      {
        itemType: MENU_SECTION_ITEM_TYPE.feature,
        icon: AutomationsColoredIcon,
        title: "header.tabs.features.keyFeatures.automations.title",
        description: "header.tabs.features.keyFeatures.automations.description",
        outline: true,
        url: AUTOMATIONS_PAGE_LINK
      },
      {
        itemType: MENU_SECTION_ITEM_TYPE.feature,
        icon: GanttColoredIcon,
        title: "header.tabs.features.keyFeatures.gantt.title",
        description: "header.tabs.features.keyFeatures.gantt.description",
        outline: true,
        url: GANTT_PAGE_LINK
      },
      {
        itemType: MENU_SECTION_ITEM_TYPE.feature,
        icon: KanbanColoredIcon,
        title: "header.tabs.features.keyFeatures.kanban.title",
        description: "header.tabs.features.keyFeatures.kanban.description",
        outline: true,
        url: KANBAN_PAGE_LINK
      },
      {
        itemType: MENU_SECTION_ITEM_TYPE.feature,
        icon: DocsColoredIcon,
        title: "header.tabs.features.keyFeatures.docs.title",
        description: "header.tabs.features.keyFeatures.docs.description",
        outline: true,
        url: WORKDOCS_PAGE_LINK
      },
      {
        itemType: MENU_SECTION_ITEM_TYPE.feature,
        icon: FilesColoredIcon,
        title: "header.tabs.features.keyFeatures.files.title",
        description: "header.tabs.features.keyFeatures.files.description",
        outline: true,
        url: FILES_PAGE_LINK
      }
    ]
  }
];

const resourcesSectionMenuItems = [
  {
    id: RESOURCES_LEARN_SECTION_ID,
    classname: MENU_SECTION_CLASSNAMES.resources,
    title: "header.tabs.resources.section.learn",
    titleLine: true,
    noSeparator: true,
    maxNumberOfItemsInColumn: 5,
    menuSectionItems: [
      {
        itemType: MENU_SECTION_ITEM_TYPE.resource,
        title: "header.tabs.resources.learn.knowledgeBase.title",
        description: "header.tabs.resources.learn.knowledgeBase.description",
        url: KNOWLEDGE_BASE_LINK
      },
      {
        itemType: MENU_SECTION_ITEM_TYPE.resource,
        title: "header.tabs.resources.learn.aboutUs.title",
        description: "header.tabs.resources.learn.aboutUs.description",
        url: ABOUT_US_PAGE_LINK
      },
      {
        itemType: MENU_SECTION_ITEM_TYPE.resource,
        title: "header.tabs.resources.learn.webinars.title",
        description: "header.tabs.resources.learn.webinars.description",
        url: WEBINARS_PAGE_LINK
      },
      // {
      //   itemType: MENU_SECTION_ITEM_TYPE.resource,
      //   title: "header.tabs.resources.learn.resourcesHub.title",
      //   description: "header.tabs.resources.learn.resourcesHub.description",
      // },
      {
        itemType: MENU_SECTION_ITEM_TYPE.resource,
        title: "header.tabs.resources.learn.blog.title",
        description: "header.tabs.resources.learn.blog.description",
        url: BLOG_PAGE_LINK
      }
    ]
  },
  {
    id: RESOURCES_CONNECT_SECTION_ID,
    title: "header.tabs.resources.section.connect",
    titleLine: true,
    noSeparator: true,
    maxNumberOfItemsInColumn: 5,
    menuSectionItems: [
      {
        itemType: MENU_SECTION_ITEM_TYPE.resource,
        title: "header.tabs.resources.connect.support.title",
        description: "header.tabs.resources.connect.support.description",
        url: SUPPORT_PAGE_LINK
      },
      {
        itemType: MENU_SECTION_ITEM_TYPE.resource,
        title: "header.tabs.resources.connect.partners.title",
        description: "header.tabs.resources.connect.partners.description",
        url: PARTNERS_PAGE_LINK
      },
      {
        itemType: MENU_SECTION_ITEM_TYPE.resource,
        title: "header.tabs.resources.connect.globalEvents.title",
        description: "header.tabs.resources.connect.globalEvents.description",
        url: GLOBAL_EVENTS_PAGE_LINK
      },
      {
        itemType: MENU_SECTION_ITEM_TYPE.resource,
        title: "header.tabs.resources.connect.digitalLift.title",
        description: "header.tabs.resources.connect.digitalLift.description",
        url: DIGITAL_LIFT_LINK
      }
    ]
  },
  {
    id: RESOURCES_EXPLORE_SECTION_ID,
    title: "header.tabs.resources.section.explore",
    titleLine: true,
    noSeparator: true,
    maxNumberOfItemsInColumn: 5,
    menuSectionItems: [
      {
        itemType: MENU_SECTION_ITEM_TYPE.resource,
        title: "header.tabs.resources.explore.templateCenter.title",
        description: "header.tabs.resources.explore.templateCenter.description",
        url: TEMPLATE_CENTER_PAGE_LINK
      },
      {
        itemType: MENU_SECTION_ITEM_TYPE.resource,
        title: "header.tabs.resources.explore.appsMarketplace.title",
        description: "header.tabs.resources.explore.appsMarketplace.description",
        url: APPS_MARKETPLACE_LINK
      },
      {
        itemType: MENU_SECTION_ITEM_TYPE.resource,
        title: "header.tabs.resources.explore.appsDeveloper.title",
        description: "header.tabs.resources.explore.appsDeveloper.description",
        url: APPS_DEVELOPER_LINK
      },
      {
        itemType: MENU_SECTION_ITEM_TYPE.resource,
        title: "header.tabs.resources.explore.customerStories.title",
        description: "header.tabs.resources.explore.customerStories.description",
        url: CUSTOMERS_PAGE_LINK
      },
      {
        itemType: MENU_SECTION_ITEM_TYPE.resource,
        title: "header.tabs.resources.explore.careers.title",
        description: "header.tabs.resources.explore.careers.description",
        url: CAREERS_PAGE_LINK
      }
    ]
  },
  {
    id: RESOURCES_TOP_STORIES_SECTION_ID,
    title: "header.tabs.resources.section.topStories",
    titleLine: true,
    noSeparator: true,
    maxNumberOfItemsInColumn: 2,
    backgroundColor: BACKGROUND_GRAY_COLOR_NAME,
    hideOnMobile: true,
    menuSectionItems: [
      {
        itemType: MENU_SECTION_ITEM_TYPE.story,
        imageSrc:
          "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/header/blog_post_2.png",
        description: "header.tabs.resources.topStories.bestCrm.description",
        url: "/blog/marketing/crm-software/",
        button: true
      },
      {
        itemType: MENU_SECTION_ITEM_TYPE.story,
        imageSrc:
          "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/header/customer_story.png",
        description: "header.tabs.resources.topStories.second.description",
        url: "/customers/oscar",
        button: true
      }
    ]
  }
];

export const LinkWithMenuMenuComponentMapping = {
  [PRODUCTS_MENU_ID]: "BaseHeaderMenuComponent",
  [USE_CASES_MENU_ID]: "BaseHeaderMenuComponent",
  [FEATURES_MENU_ID]: "BaseHeaderMenuComponent",
  [RESOURCES_MENU_ID]: "BaseHeaderMenuComponent"
};

export const SectionsLinkWithMenuMenuComponentMapping = {
  [PRODUCTS_MENU_ID]: "SectionsHeaderMenuComponent",
  [USE_CASES_MENU_ID]: "SectionsHeaderMenuComponent",
  [FEATURES_MENU_ID]: "SectionsHeaderMenuComponent",
  [RESOURCES_MENU_ID]: "SectionsHeaderMenuComponent"
};

export const SectionsHeadersMenuItemsMapping = {
  [PRODUCTS_MENU_ID]: productsSectionMenuItems,
  [USE_CASES_MENU_ID]: useCasesSectionMenuItems,
  [FEATURES_MENU_ID]: featuresSectionMenuItems,
  [RESOURCES_MENU_ID]: resourcesSectionMenuItems
};

// ===========================================================================================

// Header service functions

export const isDesktopMinisiteSecondaryMenuActive = () => {
  const headerElement = document.querySelector(`.${DESKTOP_HEADER_BASE_CLASS_NAME}`);
  if (!headerElement) return false;
  return headerElement.classList.contains("scroll-started") && !headerElement.classList.contains("scrolled-threshold");
};
